import { Grid2, IconButton, Popover } from "@mui/material";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "store/store";
import { exportFile, resetExportState } from "../store/slices/exportSlice";
import GKButton from "./GKButton";
import { DownloadIcon, DropdownIcon } from "./Icons";

interface Props {
  path: string;
  name: string;
  paramsValue?: {
    key?: string;
    value?: string;
  };
  filter?: any;
  hideType?: string[];
}

const ExportCsv = (props: Props) => {
  const dispatch = useAppDispatch();
  const userData = useAppSelector((state) => state?.user?.userData);
  const { isLoading, exportType } = useAppSelector((state) => state.export);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const { path, name, paramsValue, filter, hideType = [] } = props;

  const handleExportCsvDownload = async (exportFileType: string) => {
    await dispatch(
      exportFile({
        path,
        name,
        exportType: exportFileType,
        paramsValue,
        filter,
        userData,
      }),
    );

    setAnchorEl(null);
    dispatch(resetExportState());
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 10,
      }}
    >
      <IconButton onClick={handleClick}>
        <DownloadIcon />
        <DropdownIcon />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Grid2 container flexDirection={"column"} p={1}>
          <GKButton
            loading={exportType === "export_csv" && isLoading}
            color="dark"
            disabled={hideType.includes("csv")}
            onClick={() => handleExportCsvDownload("export_csv")}
          >
            <img
              src={`/FileIcons/csv.svg`}
              height={22}
              width={22}
              alt=""
              style={{ marginRight: 8 }}
            />
            Download CSV
          </GKButton>
          <GKButton
            color="dark"
            loading={exportType === "export_pdf" && isLoading}
            disabled={hideType.includes("pdf")}
            onClick={() => handleExportCsvDownload("export_pdf")}
          >
            <img
              src={`/FileIcons/pdf.svg`}
              height={22}
              width={22}
              alt=""
              style={{ marginRight: 8 }}
            />
            Download PDF
          </GKButton>
        </Grid2>
      </Popover>
    </div>
  );
};

export default ExportCsv;
